import React, { useEffect, useState } from 'react'
import RoleModel from './RoleModel';
import { ApiGetCallAuthKey } from '../../JS/Connector';
import PageHead from '../../Components/PageHead';
import { LogInSchoolID } from '../../JS/Common';

export default function RolesIndex() {
    const [Alerts, setAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [RolePopup, setRolePopup] = useState(false);
    const [RoleData, setRoleData] = useState([]);
    const [AddEditFlag, setAddEditFlag] = useState('');
    const [roleId, setRoleId] = useState(null);
    useEffect(() => {
        GetAllRoles(null);
    }, [])
    async function GetAllRoles() {
        setLoading(true);
        await ApiGetCallAuthKey("/getMenuDetails/" + null + '&' + LogInSchoolID).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setRoleData(responseRs?.all_menus_with_selection)
            }
        });
    }

    return (
        <div>
            <PageHead heading={"Roles"} loading={loading} Alerts={Alerts} showsearch={false} />
            <div className="GridBox mt-2 px-3 pb-3">
                <div className='row text-end'>
                    <div className="col-md-9"></div>
                    <div className="col-md-3 my-2">
                        <label className='BorderBtn text-center marginDetailsPopup me-0' title='Add Role'
                            onClick={(e) => {
                                setRolePopup(true);
                                setAddEditFlag(1);
                                setRoleId(1)
                            }}> Add Role
                            <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>
                </div>
                <div className="greyBox p-3 data-table-container">
                    <table className="table data-table">
                        <thead className='GridHeader'>
                            <tr>
                                <th scope="col" className='fw-600'>
                                    Role Name
                                </th>
                                {/* <th scope="col" className=' fw-600 text-center'>Status</th> */}
                                <th scope="col" className=' fw-600 text-center'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {RoleData.length != 0 ?
                                RoleData.map((item, i) => {
                                    return <tr key={i} className="OddEvenClass tableBorderHide">
                                        <td className="py-12">
                                            {item.access}
                                        </td>
                                        {/* <td scope='col' className='text-center py-12'>
                                            {item.school_id ?
                                                <MDBSwitch className="BgPink cursor-pointer"
                                                    name={item.name}
                                                    checked={item.status == 1 ? item?.isChecked || true : item?.isChecked || false}
                                                    onChange={(e) => handleChange(e, item.access_id, item.status)}
                                                />
                                                :
                                                '-'
                                            }
                                        </td> */}
                                        <td scope="col" className='text-center py-12'>
                                            {item.school_id ?
                                                <img src='/images/EditIconNew.svg' title='Edit Role Access' className='img-fluid pe-2 cursor-pointer'
                                                    onClick={(e) => {
                                                        setRolePopup(true);
                                                        setAddEditFlag(2);
                                                        setRoleId(item.access_id);
                                                    }} />
                                                :
                                                <img src='/images/InfoIcon.svg' title='View Role Access' className='img-fluid pe-2 cursor-pointer'
                                                    onClick={(e) => {
                                                        setRolePopup(true);
                                                        setAddEditFlag(3);
                                                        setRoleId(item.access_id);
                                                    }} />
                                            }
                                        </td>
                                    </tr>
                                })
                                :
                                <tr className="text-center">
                                    <td colSpan={15}>No Record Found</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            {RolePopup && <RoleModel isShow={RolePopup} closepopup={(e) => { setRolePopup(false); setRoleId(null); setAddEditFlag(0) }}
                flag={AddEditFlag} setLoading={setLoading} setAlerts={setAlerts}
                roleId={roleId} GetAllRoles={GetAllRoles} />}


        </div>
    )
}
